import {
  Box,
  Paper,
  Stack,
  Typography,
} from "@mui/material"


function KpiCard({
  label,
  value,
  helper,
  icon,
  trend,
  accent = "primary",
  sx = {},
}) {
  return (
    <Paper
      sx={{
        p: {
          xs: 1.5,
          sm: 1.75,
        },
        minHeight: 116,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 3,
        boxShadow: "0 6px 18px rgba(15,23,42,0.04)",
        ...sx,
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        spacing={1.2}
      >
        <Box
          sx={{
            minWidth: 0,
          }}
        >
          <Typography
            color="text.secondary"
            sx={{
              fontSize: 12.5,
              fontWeight: 800,
            }}
          >
            {label}
          </Typography>

          <Typography
            sx={{
              mt: 0.45,
              fontSize: {
                xs: 24,
                sm: 26,
              },
              lineHeight: 1,
              fontWeight: 900,
              letterSpacing: -0.4,
              color: "text.primary",
            }}
          >
            {value}
          </Typography>
        </Box>

        {icon ? (
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: 2.2,
              display: "grid",
              placeItems: "center",
              bgcolor: `${accent}.light`,
              color: `${accent}.main`,
              flexShrink: 0,

              "& svg": {
                fontSize: 21,
              },
            }}
          >
            {icon}
          </Box>
        ) : null}
      </Stack>

      <Stack
        direction="row"
        spacing={0.8}
        alignItems="center"
        sx={{
          mt: 1.35,
        }}
      >
        {trend ? trend : null}

        {helper ? (
          <Typography
            color="text.secondary"
            sx={{
              fontSize: 11.5,
              lineHeight: 1.3,
            }}
          >
            {helper}
          </Typography>
        ) : null}
      </Stack>
    </Paper>
  )
}


export default KpiCard
